const Toggle = ({
  validatorHint,
  children,
  isError,
  className,
}: {
  validatorHint: React.ReactNode;

  children: React.ReactNode;
  isError: boolean;
  className?: string;
}) => {
  return (
    <div
      className={`${isError ? " tooltip tooltip-right tooltip-open" : ""}`}
      data-tip={validatorHint}
    >
      <label
        className={`toggle ${isError ? "text-error" : className} transition-colors duration-250 mb-0.5 shadow-lg`}
      >
        {children}
      </label>
    </div>
  );
};
export default Toggle;
